export enum AmbienteEnum {
  Desarrollo = 'dev',
  Calidad = 'qa',
  Capacitacion = 'cap',
  Produccion = 'prod'
}
